import { useFieldArray, useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Label } from '@/components/ui/label';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';
import { FirstMessageType } from '@/shared/types/analytics';

interface FirstMessageTypeFilterProps {
  filterIndex: number;
}

const OPTIONS: FirstMessageType[] = ['proactive', 'reactive'];

export const FirstMessageTypeFilter = ({ filterIndex }: FirstMessageTypeFilterProps) => {
  const { t } = useTranslation();
  const { getValues, control } = useFormContext();
  const { update } = useFieldArray({ control, name: 'filters' });

  const firstMessageType = useWatch({
    control,
    name: `filters.${filterIndex}.firstMessageType`,
  }) as FirstMessageType | null | undefined;

  const handleChange = (value: string) => {
    const next = (OPTIONS as string[]).includes(value) ? (value as FirstMessageType) : null;
    const currentFilter = getValues(`filters.${filterIndex}`);
    update(filterIndex, { ...currentFilter, firstMessageType: next });
  };

  return (
    <div className="space-y-3">
      <RadioGroup value={firstMessageType ?? ''} onValueChange={handleChange} className="gap-0">
        {OPTIONS.map((option) => (
          <div
            key={option}
            className="flex items-center space-x-2 rounded-sm px-2 py-1.5 hover:bg-selected-soft"
          >
            <RadioGroupItem value={option} id={`first-message-type-${option}-${filterIndex}`} />
            <Label
              htmlFor={`first-message-type-${option}-${filterIndex}`}
              className="cursor-pointer font-normal"
            >
              {t(`filters.states.first_message_type.${option}`)}
            </Label>
          </div>
        ))}
      </RadioGroup>
    </div>
  );
};
